import React from 'react'
import styles from './Divider.module.scss'

interface DividerProps {
  orientation?: 'horizontal' | 'vertical'
  className?: never
}

export const Divider: React.FC<DividerProps> = ({ orientation = 'horizontal' }) => (
  <div className={orientation === 'horizontal' ? styles.horizontal : styles.vertical} />
)
